<template>
  <fieldset>
    <div class="tla-form-group address">
      <div v-show="showPostcodeSearchBar">
        <label class="tla-form-group__label tla-form-group__label--required" for="PostcodeSearch"
          v-html="postcodeLookupTitleLabel"></label>
          <div v-if="postcodeLookupMicrocopy">
            <label  class="tla-form-group__label" for="PostcodeSearch"
              v-html="postcodeLookupMicrocopy"></label>
          </div>
          <div v-if="questionLabel">
            <label  class="tla-form-group__label" for="PostcodeSearch"
              v-html="questionLabel"></label>
          </div>
        <div class="address__container">
          <input
            @blur="showAutoComplete = false"
            @focus="showAutoComplete = true"
            id="postcodeSearch"
            type="text"
            autocomplete="postal-code"
            class="tla-form-group__input address__postcode-field"
            :class="getValidationClass('buildingNameNumber', 'input', false)"
            name="postcodeSearch"
            v-model="postcodeSearch"
            :data-vv-scope="validationScope"
            data-vv-name="postcodeSearch"
            :placeholder="postcodeLookupFieldPlaceholder"
          />
          <button class="address__clear-button" @click="clearField">X
          </button>

        </div>

        <span class="tla-form-group__message tla-form-group__message--spaced"
          :class="getValidationClass('buildingNameNumber', 'message', false)">
          Please enter a valid address.
        </span>
      </div>

      <template v-if="hasAttemptedLookup && showFailedLookupText && failedLookupUrl.length > 0">
        <a class="address__manual" :href="failedLookupUrlFormatted">{{ failedLookupText }}</a>
      </template>

      <div v-if="!showAutoComplete && !disableManualEntry && allowManualEntry">
        <a v-if="!showAddressFields" class="address__manual" @click.prevent="showAddressList" href="#">{{
          addressEntryButtonText }}</a>
        <a v-else class="address__manual" @click.prevent="usePostcodeLookup" href="#">{{ postcodeEntryButtonText }}</a>
      </div>

      <div v-show="showAutoComplete && this.postcodeSearch != ''" id="addressDropdown"
        class="address__autocomplete address__autocomplete-list">
        <ul>
          <div>
            <li class="address__loading" v-if="this.suggestedAddress?.length === 0 && this.lookupFailed === false">
              <div class="spinner"></div>
              <div>Loading...</div>
            </li>
            <li v-if="this.lookupFailed === true">
              <div>Postcode search failed. Please enter a valid postcode or your address, and it will appear in the
                dropdown.
              </div>
            </li>
          </div>
          <li v-for="item in this.suggestedAddress" :key="item.key" :value="item.udprn">
            <a v-if="item !== null" @mousedown="selectedAddress(item)" class="address__anchor-text"
              href="javascript:void(0)">{{ item.value }}</a>
            <a v-else class="address__anchor-text">{{ invalidPostcodeResponseText }}</a>
          </li>
        </ul>
      </div>
    </div>
    <div v-show="showAddressFields">
      <input
        type="hidden"
        :name="'buildingNameNumber'"
        :value="`${buildingName}:${buildingNumber}`"
        :data-vv-scope="validationScope"
        v-validate.continues="'buildingNameNumber'"/>

      <input
        type="hidden"
        :name="'streetRequired'"
        :value="`${buildingName}:${buildingNumber}:${street}`"
        :data-vv-scope="validationScope"
        v-validate.continues="'streetRequired'"/>

      <div class="tla-form-group">
        <label class="tla-form-group__label" for="buildingName">{{buildingNameLabel}}</label>
        <input
          id="buildingName"
          type="text"
          class="tla-form-group__input"
          :class="getValidationClass('buildingNameNumber', 'input')"
          name="buildingName"
          v-model="buildingName"
          @blur="validateComponent()"
          :placeholder="buildingNamePlaceholder">
      <span class="tla-form-group__message tla-form-group__message--spaced" :class="getValidationClass('buildingNameNumber', 'message')">{{ errors.first(`${validationScope}.buildingNameNumber`) }}</span>
      </div>

      <div class="tla-form-group">
        <label class="tla-form-group__label" for="buildingNumber">{{buildingNumberLabel}}</label>
        <input
          id="buildingNumber"
          type="text"
          class="tla-form-group__input"
          :class="getValidationClass('buildingNameNumber', 'input')"
          name="buildingNumber"
          v-model="buildingNumber"
          @blur="validateComponent()"
          :placeholder="buildingNumberPlaceholder">
      <span class="tla-form-group__message tla-form-group__message--spaced" :class="getValidationClass('buildingNameNumber', 'message')">{{ errors.first(`${validationScope}.buildingNameNumber`) }}</span>
      </div>

      <div class="tla-form-group">
        <label class="tla-form-group__label" for="subBuildingName">{{subBuildingLabel}}</label>
        <input
          id="subBuildingName"
          type="text"
          class="tla-form-group__input"
          :class="getValidationClass('subBuildingName', 'input')"
          name="subBuildingName"
          v-model="subBuildingName"
          data-vv-name="subBuildingName"
          :data-vv-scope="validationScope"
          :placeholder="subBuildingPlaceholder">
      </div>

      <div class="tla-form-group">
        <label class="tla-form-group__label" for="organisationName">{{organisationLabel}}</label>
        <input
          id="organisationName"
          type="text"
          class="tla-form-group__input"
          name="organisationName"
          v-model="organisationName"
          data-vv-name="organisationName"
          :data-vv-scope="validationScope"
          :placeholder="organisationPlaceholder">
      </div>

      <div class="tla-form-group">
        <label class="tla-form-group__label" for="subStreet">{{subStreetLabel}}</label>
        <input
          id="subStreet"
          type="text"
          class="tla-form-group__input"
          name="subStreet"
          v-model="subStreet"
          data-vv-name="subStreet"
          :data-vv-scope="validationScope"
          :placeholder="subStreetPlaceholder">
      </div>

      <div class="tla-form-group">
        <label class="tla-form-group__label tla-form-group__label--required" for="street" v-html="streetLabel"></label>
        <input
          id="street"
          type="text"
          class="tla-form-group__input"
          :class="getValidationClass('streetRequired', 'input')"
          name="street"
          v-model="street"
          data-vv-name="street"
          @blur="validateComponent()"
          :data-vv-scope="validationScope"
          :placeholder="streetPlaceholder">
      <span class="tla-form-group__message tla-form-group__message--spaced" :class="getValidationClass('streetRequired', 'message')">{{ errors.first(`${validationScope}.streetRequired`) }}</span>
      </div>

      <div class="tla-form-group">
        <label class="tla-form-group__label" for="dependentLocality">{{dependentLocalityLabel}}</label>

        <input
          id="dependentLocality"
          type="text"
          class="tla-form-group__input"
          name="dependentLocality"
          v-model="dependentLocality"
          data-vv-name="dependentLocality"
          :data-vv-scope="validationScope"
          :placeholder="dependentLocalityPlaceholder">
      </div>

      <div class="tla-form-group">
        <label class="tla-form-group__label tla-form-group__label--required" for="town" v-html="townLabel"></label>

        <input
          id="town"
          type="text"
          class="tla-form-group__input"
          :class="getValidationClass('town', 'input')"
          name="town"
          v-model="town"
          data-vv-name="town"
          :data-vv-scope="validationScope"
          v-validate.initial="'required'"
          @blur="validateComponent()"
          :placeholder="townPlaceholder">
      <span class="tla-form-group__message tla-form-group__message--spaced" :class="getValidationClass('town', 'message')">{{ errors.first(`${validationScope}.town`) }}</span>
      </div>

      <div class="tla-form-group address">
        <label class="tla-form-group__label tla-form-group__label--required" for="postcode" v-html="postcodeLabel"></label>

        <input
          id="postcode"
          type="text"
          autocomplete="off"
          class="tla-form-group__input"
          :class="getValidationClass('postcode', 'input')"
          name="postcode"
          v-model="postcode"
          data-vv-name="postcode"
          :data-vv-scope="validationScope"
          v-validate.initial="'required|postcode'"
          placeholder="e.g. WC2N 5DU">
        <span class="tla-form-group__message tla-form-group__message--spaced" :class="getValidationClass('postcode', 'message')">{{ errors.first(`${validationScope}.postcode`) }}</span>
      </div>
    </div>
  </fieldset>
</template>

<script lang="ts">
import VeeValidate, { Validator } from 'vee-validate';
import {
  Component, Prop, Vue, Watch, Inject
} from 'vue-property-decorator';
import {
  namespace
} from 'vuex-class';
import Debounce from 'debounce-decorator';
import ExtraData from '@/models/ExtraData';
import { tokenService } from '@/services/TokenService';
import Address from '../../models/Address';
import KeyValue from '../../models/KeyValue';
import { lookupService } from '../../services/LookupService';
import { validationService } from '../../services/ValidationService';
import AddressValidationMessages from '../../validation/address';

const EnquiryModule = namespace('enquiryModule');
const AddressModule = namespace('addressModule');

Vue.use(VeeValidate, AddressValidationMessages);

// Custom vee-validate
Validator.extend('postcode', {
  getMessage: (field: string) => 'Please enter a valid postcode',
  validate: (value: string) => validationService
    .isPostcodeValid(value)
});

Validator.extend('buildingNameNumber', {
  getMessage: (field: string) => 'Please enter either a building name or building number',
  validate: (value: string) => validationService
    .isBuildingNameNumberValid()
});

Validator.extend('streetRequired', {
  getMessage: (field: string) => 'Please enter a street',
  validate: (value: string) => validationService
    .isStreetValid()
});

@Component
export default class AddressLookupComponent extends Vue {
  @Inject('$validator') public $validator!: Validator;

  @EnquiryModule.Action public submitShowEnterPostcodeManually;

  @AddressModule.Action public submitBuildingName;

  @AddressModule.Action public submitSubBuildingName;

  @AddressModule.Action public submitBuildingNumber;

  @AddressModule.Action public submitStreet;

  @AddressModule.Action public submitDependentLocality;

  @AddressModule.Action public submitTown;

  @AddressModule.Action public submitPostcode;

  @AddressModule.Action public submitSubStreet;

  @AddressModule.Action public submitOrganisationName;

  @AddressModule.Action public submitSubNationalArea;

  @AddressModule.Action public submitCountry;

  @AddressModule.Action public submitLatitude;

  @AddressModule.Action public submitLongitude;

  @EnquiryModule.Getter public showEnterPostcodeManually;

  @AddressModule.Getter public address;

  private suggestedAddress: KeyValue[] = [];

  private fullAddress: Address = new Address();

  public showPostcodeSearchBar: boolean = true;

  public showAutoComplete: boolean = false;

  private addressOverwritten: boolean = false;

  private cloneAddress: Address = new Address();

  private addressModel: Address = new Address();

  private addressSuggestion: string = '';

  private oldPostcodeValue: string = '';

  public hasAttemptedLookup: boolean = false;

  public allowManualEntry: boolean = false;

  private lookupFailed: boolean = false;

  @Prop({ default: null })
  public validationScope!: string;

  @Prop({ default: 'Postcode <span>*</span>' })
  public postcodeLookupTitleLabel!: string;

  @Prop({ default: 'Please enter your postcode and select your address from the options' })
  public postcodeLookupMicrocopy!: string;

  @Prop({ default: 'Enter Address Manually' })
  public addressEntryButtonText!: string;

  @Prop({ default: 'Use Postcode Lookup' })
  public postcodeEntryButtonText!: string;

  @Prop({ default: 'Start typing your postcode' })
  public postcodeLookupFieldPlaceholder!: string;

  @Prop({ default: 'Postcode Not Found' })
  public invalidPostcodeResponseText!: string;

  @Prop({ default: 'Building Name' })
  public buildingNameLabel!: string;

  @Prop({ default: 'e.g. Broadgate Tower' })
  public buildingNamePlaceholder!: string;

  @Prop({ default: 'Building Number' })
  public buildingNumberLabel!: string;

  @Prop({ default: 'e.g. 107' })
  public buildingNumberPlaceholder!: string;

  @Prop({ default: 'Sub Building Name/Number' })
  public subBuildingLabel!: string;

  @Prop({ default: 'e.g. Flat 4B' })
  public subBuildingPlaceholder!: string;

  @Prop({ default: 'Organisation Name' })
  public organisationLabel!: string;

  @Prop({ default: 'e.g. The Lead Agency' })
  public organisationPlaceholder!: string;

  @Prop({ default: 'Street <span>*</span>' })
  public streetLabel!: string;

  @Prop({ default: 'e.g. Broadgate Street' })
  public streetPlaceholder!: string;

  @Prop({ default: 'Sub Street' })
  public subStreetLabel!: string;

  @Prop({ default: 'e.g. Princes Gardens' })
  public subStreetPlaceholder!: string;

  @Prop({ default: 'District/Area' })
  public dependentLocalityLabel!: string;

  @Prop({ default: 'e.g. Westminster' })
  public dependentLocalityPlaceholder!: string;

  @Prop({ default: 'Town/City <span>*</span>' })
  public townLabel!: string;

  @Prop({ default: 'e.g. London' })
  public townPlaceholder!: string;

  @Prop({ default: 'Postcode <span>*</span>' })
  public postcodeLabel!: string;

  @Prop({ default: 'e.g. WC2N 5DU' })
  public postcodePlaceholder!: string;

  @Prop({ default: false })
  public disableManualEntry!: boolean;

  @Prop({ default: false })
  public showFailedLookupText!: boolean;

  @Prop({ default: 'Address not found?' })
  public failedLookupText!: string;

  @Prop({ default: '' })
  public failedLookupUrl!: string;

  @Prop({ default: '' })
  public questionLabel!: string;

  @Watch('currentAddress', { deep: true })
  public onAddressChange(address: Address) {
    const stringifiedAddress = JSON.stringify(address);
    const stringifiedCloneAddress = JSON.stringify(this.cloneAddress);

    if (!this.showAddressFields) {
      this.addressOverwritten = false;
    } else if (
      stringifiedAddress !== stringifiedCloneAddress && this.showAddressFields
    ) {
      this.addressOverwritten = true;
      this.addressSuggestion = '';
    } else if (stringifiedAddress === stringifiedCloneAddress) {
      this.addressOverwritten = false;
    }

    this.setAddressUpdated(this.addressOverwritten);
    this.validateComponent();
  }

  @Watch('postcodeSearch')
  public async postcodeFastUpdate() {
    this.lookupFailed = false;
    if (validationService.isPostcodeValid(this.postcodeSearch)) {
      this.suggestedAddress = await lookupService.fetchSuggestions(this.postcodeSearch);
    }
  }

  @Debounce(700)
  @Watch('postcodeSearch')
  public async postcodeAutoComplete() {
    this.hasAttemptedLookup = true;

    if (this.suggestedAddress.length === 0 || this.postcodeSearch.length <= 20) {
      this.oldPostcodeValue = this.postcodeSearch;
    }

    if (this.oldPostcodeValue === this.postcodeSearch) {
      if (this.postcodeSearch !== '') {
        this.suggestedAddress = await lookupService.fetchSuggestions(this.postcodeSearch);

        if (this.suggestedAddress.length === 0 && validationService.isPostcodeValid(this.postcodeSearch)) {
          this.allowManualEntry = true;
        } else if (this.suggestedAddress?.length === 0) {
          this.lookupFailed = true;
        } else {
          this.allowManualEntry = false;
        }
      }
    }

    return this.suggestedAddress;
  }

  private clearField() {
    this.postcodeSearch = '';
  }

  public async selectedAddress(suggestion: KeyValue) {
    this.addressModel = await lookupService.fetchAddress(suggestion.key);

    this.submitLatitude(this.addressModel.latitude);
    this.submitLongitude(this.addressModel.longitude);

    this.country = this.addressModel.country;
    this.subNationalArea = this.addressModel.subNationalArea;
    this.postcode = this.addressModel.postcode;
    this.buildingName = this.addressModel.buildingName;
    this.buildingNumber = this.addressModel.buildingNumber;
    this.street = this.addressModel.street;
    this.dependentLocality = this.addressModel.dependentLocality;
    this.town = this.addressModel.town;
    this.subStreet = this.addressModel.subStreet;
    this.organisationName = this.addressModel.organisationName;
    this.subBuildingName = this.addressModel.subBuildingName;

    this.showAddressList(false);
    this.postcodeSearch = suggestion.value;
    this.addressSuggestion = suggestion.value;

    this.$validator.validateAll(this.validationScope).then(() => {
      const hasError = this.$validator.errors.items.find((e) => (e.field === 'buildingNameNumber' || e.field === 'postcode' || e.field === 'streetRequired') && e.scope === this.validationScope);

      if (hasError && !this.disableManualEntry) {
        this.showAddressFields = true;
        this.showPostcodeSearchBar = false;
        this.allowManualEntry = true;
      } else {
        this.showAddressFields = false;
        this.showPostcodeSearchBar = true;
        this.allowManualEntry = false;
      }
    });
  }

  public showAddressList(showAddressFields: boolean = true) {
    this.showAddressFields = showAddressFields;
    this.postcodeSearch = '';
    this.showPostcodeSearchBar = false;
    this.cloneAddress = this.addressModel;
    this.validateComponent();
  }

  public usePostcodeLookup() {
    if (this.addressModel !== null) {
      this.postcodeSearch = this.addressSuggestion;
    }

    this.showAddressFields = false;
    this.showPostcodeSearchBar = true;
    this.cloneAddress = new Address();
    this.setAddressUpdated(this.addressOverwritten);
  }

  public setAddressUpdated(value: boolean) {
    if (this.addressOverwritten) {
      const extraData = new ExtraData('addressUpdated', value.toString());
      this.$store.dispatch('enquiryModule/submitExtraData', extraData);
    } else {
      this.$store.dispatch('enquiryModule/submitRemoveExtraData', 'addressUpdated');
    }
  }

  get failedLookupUrlFormatted(): string {
    return tokenService.replaceToken(this.failedLookupUrl);
  }

  get currentAddress(): Address {
    return this.address;
  }

  get showAddressFields(): boolean {
    return this.showEnterPostcodeManually;
  }

  set showAddressFields(value: boolean) {
    this.submitShowEnterPostcodeManually(value);
  }

  get buildingName(): string {
    return this.address.buildingName;
  }

  set buildingName(buildingName: string) {
    this.submitBuildingName(buildingName);
  }

  get subBuildingName(): string {
    return this.address.subBuildingName;
  }

  set subBuildingName(subBuildingName: string) {
    this.submitSubBuildingName(subBuildingName);
  }

  get buildingNumber(): string {
    return this.address.buildingNumber;
  }

  set buildingNumber(buildingNumber: string) {
    this.submitBuildingNumber(buildingNumber);
  }

  get street(): string {
    return this.address.street;
  }

  set street(street: string) {
    this.submitStreet(street);
  }

  get dependentLocality(): string {
    return this.address.dependentLocality;
  }

  set dependentLocality(dependentLocality: string) {
    this.submitDependentLocality(dependentLocality);
  }

  get town(): string {
    return this.address.town;
  }

  set town(town: string) {
    this.submitTown(town);
  }

  get subStreet(): string {
    return this.address.subStreet;
  }

  set subStreet(subStreet: string) {
    this.submitSubStreet(subStreet);
  }

  get organisationName(): string {
    return this.address.organisationName;
  }

  set organisationName(organisationName: string) {
    this.submitOrganisationName(organisationName);
  }

  get subNationalArea(): string {
    return this.address.subNationalArea;
  }

  set subNationalArea(subNationalArea: string) {
    this.submitSubNationalArea(subNationalArea);
  }

  get country(): string {
    return this.address.country;
  }

  set country(country: string) {
    this.submitCountry(country);
  }

  get postcode(): string {
    return this.address.postcode;
  }

  set postcode(postcode: string) {
    this.submitPostcode(postcode);
  }

  public postcodeSearch: string = '';

  public getValidationClass(fieldName: string, fieldType: string, initial: boolean = true) {
    return validationService
      .getValidationClass(this.$validator, fieldName, fieldType, false, initial, this.validationScope);
  }

  public validateComponent() {
    this.$validator.validateAll(this.validationScope);
  }

  public created() {
    this.validateComponent();
    this.$validator.localize('en', AddressValidationMessages.english);
    this.setAddressUpdated(this.addressOverwritten);
  }
}
</script>
